export default "__VITE_ASSET__470e3e83__"